import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Plans from "../../../plan";

export default () => (
  <Switch>
    <Route path="/plans" component={Plans} />
  </Switch>
);
